// A plain synchronous read of the browser's connectivity flag. This used to
// also register a fresh pair of 'online'/'offline' window listeners on every
// call -- but nothing ever read the variable those listeners mutated (it was
// local to that call's closure and discarded once this function returned),
// so every caller (called on every poll tick, every fetch, every render in
// some cases) leaked two listeners with no cleanup and no effect on the
// return value. Removed; callers that need to react to connectivity changes
// over time should track it in state via their own effect instead.
export const internetConnect = () => navigator.onLine
